export default __webpack_public_path__ + "static/media/bossa.a8f5bf20.mp3";